import { render, staticRenderFns } from "./DownloadChromePluginPanel.vue?vue&type=template&id=1d1bec84&scoped=true"
import script from "./DownloadChromePluginPanel.vue?vue&type=script&lang=ts"
export * from "./DownloadChromePluginPanel.vue?vue&type=script&lang=ts"
import style0 from "./DownloadChromePluginPanel.vue?vue&type=style&index=0&id=1d1bec84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1bec84",
  null
  
)

export default component.exports